import { getImportCompanyUnitDetail, getImportCompanyUnitErrors } from "./articleImportCompanyUnits";
import { getImportServerErrors } from "./articleImportValidation";

// Paths use IDs, so editing a name or barcode never changes the hierarchy.
export const getArticleImportTreePath = row => row.path;

export function buildArticleImportTree(page, companyUnits, articleUnitIds) {
  const result = [];
  page.forEach(({ row, errors }) => {
    const parent = `article-${row.id}`;
    result.push({ id: parent, path: [parent], kind: "article", article: row, errors, information: getImportServerErrors(row, undefined, true) });
    (row.companyUnitIds || []).forEach(unitId => {
      const detail = getImportCompanyUnitDetail(row, unitId);
      result.push({
        id: `${parent}-unit-${unitId}`, path: [parent, `unit-${unitId}`],
        kind: "unit", article: row, unitId, detail,
        unitName: companyUnits.get(unitId)?.UnitName || "Njësi e panjohur",
        errors: { ...getImportCompanyUnitErrors(row, detail, articleUnitIds), ...getImportServerErrors(row, unitId) },
        information: getImportServerErrors(row, unitId, true),
      });
    });
  });
  return result;
}
